import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { FormBuilder, FormControl, FormArray, FormGroup, Validators, AbstractControl } from '@angular/forms';
import { CareerInfoService } from '../../../_services/index';

@Component({
  selector: 'academic-major-questiontype',
  templateUrl: './academicmajor.questiontype.component.html',
  providers:[CareerInfoService]
})
export class AcademicMajorComponent implements OnInit, OnDestroy {
  @Input() required:boolean;
  @Input() prompt:string;
  @Input() tooltip:string;
  @Input() questionid:number;
  @Input() questioninitmixin:any;
  @Input() disabled:boolean;
  formError:false;
  value:'';
  formSegment:FormGroup;
  academicMajorData:Array<any>;

  constructor(
    public api: CareerInfoService
  ){
  }

  isValid():boolean {
    if(this.disabled) {
      return true;
    }
    return !!this.value;
  }
  validate():boolean {
    return true;
  }

  public getValue():object {
    var result={};
    if(!this.disabled) {
      result[this.questionid]=this.formSegment.value['item'];
    } else {
      result[this.questionid]=null;
    }
    return result;
  }

  ngOnInit() {
    var init={};
    init['item']=new FormControl(this.value);
    this.formSegment=new FormGroup(init);


    var sub = this.api.academicMajorList()
      .subscribe(responseData => {
        sub.unsubscribe();
          if ( responseData.status === 1) {
              this.academicMajorData = responseData.data.academicmajor;
              this.formSegment.patchValue({
                item: this.value || this.academicMajorData[0].name
              });
          }
      });
  }

  ngOnDestroy() {
  }
}




// WEBPACK FOOTER //
// /home/aschmidt/websites/onefuturecv.org/onefuture-frontend/src/app/pages/questionnaire/elements/academicmajor.questiontype.component.ts